import React from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "@/lib/site";

export const WhatsAppFAB = () => {
  return (
    <motion.a
      href={buildWhatsAppLink("default")}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0.85, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 0.6, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.04 }}
      whileTap={{ scale: 0.96 }}
      className="fixed bottom-6 right-6 z-50 hidden md:inline-flex items-center gap-3 bg-sage text-ivory pl-4 pr-5 py-3 rounded-full shadow-[0_10px_30px_-10px_rgba(30,30,30,0.3)] animate-soft-pulse hover:bg-sage-700 transition-colors"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-fab"
    >
      <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-ivory/15">
        <MessageCircle size={18} strokeWidth={1.75} />
      </span>
      <span className="hidden sm:inline text-sm font-medium tracking-wide">
        Chat with us
      </span>
    </motion.a>
  );
};

export default WhatsAppFAB;
